import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../../shared/services/service.service';
import { GetServicesListResponse, GetServicesListModel } from '../../../shared/models/service.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'service-voucher-start-pick-service.component.html',
  styleUrls: ['./service-voucher-start-pick-service.component.scss']
})
export class ServiceVoucherStartPickServiceComponent implements OnInit {
  servicesListResponse: GetServicesListResponse | null = null;
  loading: boolean = true;

  constructor(
    private serviceService: ServiceService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.serviceService.getServicesList().subscribe(
      (response) => {
        this.servicesListResponse = response;
        if (!this.servicesListResponse || this.servicesListResponse.services.length === 0) {
          console.warn('No services available. Staying on the current page.');
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      (error) => {
        console.error('Error fetching services list:', error);
        this.loading = false;
      }
    );
  }

  continueNextStep(serviceId: number | undefined) {
    if (serviceId !== undefined) {
      this.activeUserLocalDataService.newServiceVoucherServiceId = serviceId;
      this.router.navigate(['/service-voucher-start-odometer']);
    } else {
      console.error('Service ID is undefined');
    }
  }

  navigateToServicePickCar() {
    this.router.navigate(['/service-pick-car']);
  }
}